import {
  Component, Input, OnDestroy, OnInit,
} from '@angular/core';
import { CardDataItem } from '@models/cardDataItem';
import { DashboardComponentInterface } from '@models/dashboard';
import { SmartwatchService } from '@services/smartwatch.service';
import { SmartwatchDashboardConfiguration } from './smartwatch-dashboard-configuration';

@Component({
  selector: 'app-smartwatch-dashboard',
  templateUrl: './smartwatch-dashboard.component.html',
})
export class SmartwatchDashboardComponent implements OnInit, OnDestroy, DashboardComponentInterface {
  @Input() configuration!: SmartwatchDashboardConfiguration;

  intervalTime = 10000;

  protected smartwatchData: CardDataItem[] = [new CardDataItem('Loading', 0)];

  protected isLoading = false;

  private isFirstLoad = true;

  private interval?: ReturnType<typeof setInterval> = undefined;

  constructor(
    private smartwatchService: SmartwatchService,
  ) {}

  ngOnInit() {
    this.interval = setInterval(() => this.loadData(), this.intervalTime);
  }

  ngOnDestroy() {
    clearInterval(this.interval);
  }

  setConfiguration(configuration: unknown): void {
    this.configuration = { ...this.configuration, ...configuration as object };
  }

  loadData() {
    if (this.isFirstLoad) {
      this.isFirstLoad = false;
      this.isLoading = true;
    }
    this.smartwatchService.getSmartwatchStatus().subscribe((count) => {
      this.smartwatchData = count.map((item) => new CardDataItem(item.status, item.count));
      this.isLoading = false;
    });
  }
}
